import React, { useState } from 'react';
import Checkbox from 'components/base/Checkbox';
import styled from 'styled-components';

const StyledCheckbox = styled(Checkbox)`
  width: 16px;
  padding: 0;
`;

const BulkAccountsCheckbox = ({
  account,
  accountsBulkSelected,
  setAccountsBulkSelected,
  isScimEnabled
}) => {
  const { id, isPending } = account;
  const [isChecked, setIsChecked] = useState(false);
  const isDisabled = isPending || isScimEnabled;

  const handleOnChange = (isChecked, setIsChecked) => {
    setIsChecked(!isChecked);
    const checked = !isChecked;
    if (checked) {
      setAccountsBulkSelected(accountsBulkSelected => [
        ...accountsBulkSelected,
        id
      ]);
    } else {
      setAccountsBulkSelected(accountsBulkSelected => {
        const accountsSelected = [...accountsBulkSelected];
        const index = accountsSelected.indexOf(id);
        accountsSelected.splice(index, 1);
        return accountsSelected;
      });
    }
  };

  return (
    <StyledCheckbox
      checked={isChecked}
      disabled={isDisabled}
      onChange={() => {
        handleOnChange(isChecked, setIsChecked);
      }}
      color='primary'
      inputProps={{ 'aria-label': 'Select' }}
    />
  );
};

export default BulkAccountsCheckbox;
